import { render, staticRenderFns } from "./Garage.vue?vue&type=template&id=2cbd95a4"
import script from "./Garage.vue?vue&type=script&lang=js"
export * from "./Garage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports